export default __webpack_public_path__ + "static/media/i-storage.e6a00b8a.png";